import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { IShortAnswerField } from '@shared/interfaces';

@Component({
  selector: 'app-short-answers',
  templateUrl: './short-answers.component.html',
  styleUrls: ['./short-answers.component.scss'],
})
export class ShortAnswersComponent implements OnInit {
  @Input() shortAnswer: IShortAnswerField;
  @Input() control: FormControl;
  @Output() valueChange = new EventEmitter<any>();

  ngOnInit(): void {
    if (this.shortAnswer.isRequired) {
      this.control.setValidators([Validators.required]);
      this.control.updateValueAndValidity();
    }

    // Emit whenever value changes
    this.control.valueChanges.subscribe((val) => {
      this.valueChange.emit(val);
    });
  }
}
